var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      this.cell !== null
        ? _c("div", [
            _c(
              "table",
              [
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("txtName")))]),
                  _vm._v(" "),
                  _c("td", { staticClass: "pl-4" }, [
                    _vm._v(_vm._s(_vm.cell.name))
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("txtDescription")))]),
                  _vm._v(" "),
                  _c("td", { staticClass: "pl-4" }, [
                    _vm._v(_vm._s(_vm.cell.description))
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("txtSupplier")))]),
                  _vm._v(" "),
                  _c("td", { staticClass: "pl-4" }, [
                    _vm._v(_vm._s(_vm.cell.supplier))
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("txtComment")))]),
                  _vm._v(" "),
                  _c("td", { staticClass: "pl-4" }, [
                    _vm._v(_vm._s(_vm.cell.comment))
                  ])
                ]),
                _vm._v(" "),
                _vm.cellMoreDetails
                  ? [
                      _c("tr", [
                        _c("th", [_vm._v(_vm._s(_vm.$t("txtLine")))]),
                        _vm._v(" "),
                        _c("td", { staticClass: "pl-4" }, [
                          _vm._v(_vm._s(_vm.line && _vm.line.name))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [_vm._v(_vm._s(_vm.$t("txtIdent")))]),
                        _vm._v(" "),
                        _c("td", { staticClass: "pl-4" }, [
                          _vm._v(_vm._s(_vm.cell.ident))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [_vm._v(_vm._s(_vm.$t("txtCostCenter")))]),
                        _vm._v(" "),
                        _c("td", { staticClass: "pl-4" }, [
                          _vm._v(_vm._s(_vm.cell.costCenter))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [_vm._v(_vm._s(_vm.$t("txtMeterStart")))]),
                        _vm._v(" "),
                        _c("td", { staticClass: "pl-4" }, [
                          _vm._v(
                            _vm._s(_vm.cell.engineHours) +
                              " " +
                              _vm._s(_vm.cell.engineHoursUnit)
                          )
                        ])
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { attrs: { colspan: "2" } }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-secondary",
                        on: {
                          click: function($event) {
                            _vm.cellMoreDetails = !_vm.cellMoreDetails
                          }
                        }
                      },
                      [
                        _vm.cellMoreDetails
                          ? [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("activityLessDetails")) +
                                  "\n              "
                              ),
                              _c("i", { staticClass: "fas fa-chevron-up" })
                            ]
                          : [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("activityMoreDetails")) +
                                  "\n              "
                              ),
                              _c("i", { staticClass: "fas fa-chevron-down" })
                            ]
                      ],
                      2
                    )
                  ])
                ])
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("ImageViewer", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isCellMedia,
            expression: "isCellMedia"
          }
        ],
        attrs: { isShowDelete: false, medias: _vm.medias }
      }),
      _vm._v(" "),
      _c(
        "strong",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isCellMedia,
              expression: "!isCellMedia"
            }
          ]
        },
        [_vm._v(" " + _vm._s(_vm.$t("activityNoData")))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }